import React, { useState, useContext } from "react";
import { useRouterParams } from "../../../abstracts";
import {
  AddNewSectionSliderPanel,
  AddToolTip,
  MapAndTransformOutputFixedWidthField,
} from "../../../components";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Tab from "react-bootstrap/Tab";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil } from "@fortawesome/pro-regular-svg-icons";
import { Link } from "react-router-dom";
import FieldSetupSlider from "./FieldSetupSlider";
import { fixedWidthOutputMappingSave } from "../../../services";
import {
  manageMapperStore,
  MANAGE_MAPPER_POST_API_ERROR,
  setManageMapperToastInfo,
  setMapperPostResponse,
} from "../../../contexts";

const MapAndTransformOutputFixedWidthContainer = (props) => {
  const { dispatch } = useContext(manageMapperStore);
  const { profileId } = useRouterParams();
  const [activeSectionIndex, setActiveSectionIndex] = useState(0);
  const { sections, setSections, dataModel } = props;
  const [sliderState, setSliderState] = useState(false);
  const [isSectionEdit, setIsSectionEdit] = useState(false);
  const [sliderIndex, setSliderIndex] = useState();
  const [showSlideOut, setShowSlideOut] = useState(false);
  const [fieldIndex, setFieldIndex] = useState(0);
  const [fieldArrayName, setFieldArrayName] = useState(null);

  const onDeleteSection = () => {
    let data = sections?.filter((item, i) => !(i == activeSectionIndex));
    setSections(data);
    fixedWidthOutputMappingSave({
      id: profileId ?? 0,
      fixedWidthOutputSections: data,
    })
      .then((response) => {
        let newValues = response?.fixedWidthOutputSections
          ?.filter((_) => !_.isDeleted)
          ?.map((item) => {
            return {
              ...item,
              fixedWidthOutputSectionFields: item.fixedWidthOutputSectionFields?.filter(
                (_) => !_.isDeleted
              ),
            };
          });
        let res = {
          ...response,
          fixedWidthOutputSections: newValues,
        };
        dispatch(setMapperPostResponse(res));
        dispatch(
          setManageMapperToastInfo({
            showToast: true,
            toastMessage: "Data saved successfully",
          })
        );
      })
      .catch((error) => {
        dispatch({
          type: MANAGE_MAPPER_POST_API_ERROR,
          payload: "Something went wrong! please try again.",
        });
      });
    if (activeSectionIndex !== 0) setActiveSectionIndex(activeSectionIndex - 1);
    setSliderState(!sliderState);
  };

  const fixedWidthData = sections[
    activeSectionIndex
  ]?.fixedWidthOutputSectionFields?.sort((a, b) => a.from - b.from);

  return (
    <div>
      {sections.length ? (
        <Tab.Container id="left-tabs-example" defaultActiveKey="first">
          <Row>
            <Col sm={3} className="pr-0">
              <div className="sections-tab-container">
                <div className="d-flex flex-row m-2 p-3 bb-1 justify-content-between align-items-center">
                  <div className="sections-title">Sections</div>
                  <div
                    className="add-section-button"
                    onClick={() => {
                      setSliderIndex();
                      setSliderState(!sliderState);
                      setIsSectionEdit(false);
                    }}
                  >
                    Add +
                  </div>
                </div>
                <div className="flex-column">
                  {sections?.map((section, index) => (
                    <div
                      className={`section-name p-2 pl-3 ${
                        index == activeSectionIndex ? "active-section" : ""
                      }`}
                      onClick={() => setActiveSectionIndex(index)}
                    >
                      <AddToolTip
                        className={
                          index == activeSectionIndex
                            ? "add-blueline"
                            : "add-greyline"
                        }
                        name={section?.name}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </Col>
            <Col sm={9} className="pl-0">
              <div className="sections-tab-content">
                <div className="d-flex flex-row justify-content-between m-2 p-3 bb-1">
                  <div className="section-heading w-50">
                    <AddToolTip name={sections[activeSectionIndex]?.name} />
                  </div>
                  <div>
                    <FontAwesomeIcon
                      icon={faPencil}
                      className="ml-4 section-edit-icon"
                      onClick={() => {
                        setSliderIndex(activeSectionIndex);
                        setSliderState(!sliderState);
                        setIsSectionEdit(true);
                      }}
                    />
                  </div>
                </div>
                <div className="d-flex flex-column m-2 p-2">
                  {fixedWidthData?.map((field, index) => (
                    <MapAndTransformOutputFixedWidthField
                      data={field}
                      setFieldIndex={setFieldIndex}
                      index={index}
                      setShowSlideOut={setShowSlideOut}
                    />
                  ))}
                  <div
                    className="configure-new-field-button m-3 p-3"
                    onClick={() => {
                      setShowSlideOut(true);
                      setFieldIndex();
                    }}
                  >
                    Configure New Field
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Tab.Container>
      ) : (
        <div className="disp-flex-row marg-top-60">
          <div className="bold-heading">Add A New Section</div>
          <Link
            className="click-me"
            onClick={() => {
              setSliderIndex();
              setSliderState(!sliderState);
            }}
          >
            Click Here
          </Link>
        </div>
      )}
      <AddNewSectionSliderPanel
        isOpen={sliderState}
        setSections={setSections}
        sections={sections}
        setSliderState={setSliderState}
        index={sliderIndex}
        onDeleteSection={onDeleteSection}
        isSectionEdit={isSectionEdit}
        profileId={profileId}
      />
      <FieldSetupSlider
        setShowSlideOut={setShowSlideOut}
        mappedData={sections}
        setMappedData={setSections}
        dataModel={dataModel}
        fieldIndex={fieldIndex}
        setFieldIndex={setFieldIndex}
        index={activeSectionIndex}
        showSlideOut={showSlideOut}
        isFixedWidth={true}
        fieldArrayName={fieldArrayName}
        setFieldArrayName={setFieldArrayName}
        sectionType={sections[activeSectionIndex]?.sectionType}
        profileId={profileId}
      />
    </div>
  );
};

export default MapAndTransformOutputFixedWidthContainer;
